export default {
  data() {
    return {
      assignmentsDataLoaded: false,
    };
  },
  computed: {
    assignments: {
      cache: false,
      get() {
        return this.$store.getters.assignedAssignments;
      }
    },
    me: {
      cache: false,
      get() {
        return this.$store.getters.user;
      }
    },
    groupMembers: {
      cache: false,
      get() {
        return this.$store.getters.groupMembers;
      }
    },
    unassignedRecordings: {
      cache: false,
      get() {

        let assignedRecordingIds = [];
        _.map(this.assignments, (assignment) => {
          assignment.recordings.forEach((rec) => assignedRecordingIds.push(rec.recordingId));
        });

        return _.filter(
          this.recordings,
          (r) => {
            return assignedRecordingIds.indexOf(r.recordingId) === -1 &&
              r.userId === this.me.userId;
          }
        );
      }
    },
    assignedRecordings: {
      cache: false,
      get() {
        let merged = _.merge(_.keyBy(this.assignment.recordings, 'recordingId'), _.keyBy(this.recordings, 'recordingId'));
        return _.filter(
          merged,
          (r) => {
            return typeof r.assignmentId !== 'undefined' &&
              r.userId === this.me.userId;
          }
        );
      }
    },
    assignmentRecordingsByAssignment: {
      cache: false,
      get() {
        let assignments = {};
        _.forEach(this.assignments, (assignment) => {
          let assignmentRecordings =  _.filter(
            assignment.recordings,
            (r) => {
              return r.userId !== this.me.userId;
            }
          );
          assignments[assignment.assignmentId] = {};

          _.map(assignmentRecordings, (r) => {
            if (!assignments[assignment.assignmentId][r.userId]) {
              assignments[assignment.assignmentId][r.userId] = [];
            }
            assignments[assignment.assignmentId][r.userId].push(r);
          });
        });
        return assignments;
      }
    },
    sharedRecordings: {
      cache: false,
      get() {
        return this.$store.getters.groupRecordings;
      }
    },
    recordings: {
      cache: false,
      get() {
        return this.$store.getters.recordings;
      }
    },
  },
  methods: {
    /*
    secondaryLookups() {
      const lookups = [];
      const groups = Object.keys(this.groupMembers);
      groups.forEach((groupId) => {
        lookups.push(this.$store.dispatch('listGroupRecordings', {groupId}));
      });
      return window.Promise.all(lookups);
    }
    */
  },
  created() {
    if (typeof this.topLevelPage !== 'undefined' && this.topLevelPage === false) {
      return true;
    }

    const lookups = (this.$store.getters.assignedAssignments.length &&
      this.$store.getters.recordings.length &&
      this.$store.getters.groupMembers.length) ?
      [] : [
        this.$store.dispatch('listGroupMembers'),
        this.$store.dispatch('listRecordings'),
        this.$store.dispatch('getAssignedAssignments'),
      ];

    this.assignmentsDataLoaded = false;
    window.Promise.all(lookups)
      .finally(() => {
        // Populate this.assignment from the URL
        if (this.$router.currentRoute.params.assignmentId) {
          this.assignment =
            _.find(
              this.assignments,
              s => s.assignmentId === this.$router.currentRoute.params.assignmentId
            );
        }

        this.assignmentsDataLoaded = true;
        if (typeof this.assignmentsLoaded !== 'undefined') {
          this.assignmentsLoaded();
        }
      });
  },
};
